export default __webpack_public_path__ + "static/media/menu3.f67e394d.webp";